const steps = [
  {
    icon: "ri-search-line",
    step: "01",
    title: "挑选心仪漫画",
    desc: "在热门推荐或主题分类中，找到一部想离线追读的作品。",
  },
  {
    icon: "ri-download-cloud-2-line",
    step: "02",
    title: "一键缓存下载",
    desc: "点击「缓存全集」，把整话或整部作品下载到设备本地。",
  },
  {
    icon: "ri-archive-drawer-line",
    step: "03",
    title: "全集打包收藏",
    desc: "自动归入收藏夹，整部作品打包整理，随时取用不丢失。",
  },
  {
    icon: "ri-flight-takeoff-line",
    step: "04",
    title: "离线畅快追读",
    desc: "无网络也能随手翻看，通勤、旅行、深夜里随时开读。",
  },
];

const stats = [
  { num: "1200+", label: "支持离线作品" },
  { num: "60+", label: "覆盖主题类型" },
  { num: "300万+", label: "累计缓存次数" },
  { num: "4.9/5", label: "读者好评均分" },
];

export default function HowItWorks() {
  return (
    <section id="how" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="text-sm font-semibold uppercase tracking-widest text-primary-600">
              使用教程
            </p>
            <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              四步搞定离线收藏
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              洒洒漫画网的下载缓存流程非常简单，跟着下面四步，
              就能把整部漫画全集打包离线收藏，随时随地无网络畅读。
            </p>

            <div className="mt-8 space-y-4">
              {steps.map((s) => (
                <div
                  key={s.step}
                  className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div className="flex flex-1 flex-col gap-0.5 sm:flex-row sm:items-start sm:justify-between">
                    <div>
                      <h3 className="text-base font-bold text-foreground-900">{s.title}</h3>
                      <p className="mt-1 text-sm text-foreground-600">{s.desc}</p>
                    </div>
                    <span className="font-heading text-2xl font-black text-secondary-300">
                      {s.step}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="text-lg font-bold text-foreground-900">洒洒漫画网数据一览</h3>
            <p className="mt-1 text-sm text-foreground-500">
              用数据说话，离线阅读已经走进千万读者的日常。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div
                  key={s.label}
                  className="rounded-lg bg-background-100 p-5 text-center"
                >
                  <p className="font-heading text-3xl font-black text-primary-600">
                    {s.num}
                  </p>
                  <p className="mt-1 text-sm text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
            <div className="mt-6 rounded-lg bg-gradient-to-br from-primary-500 to-accent-500 p-6 text-background-50">
              <p className="font-heading text-lg font-bold">体验离线看漫画自由</p>
              <p className="mt-2 text-sm text-background-100/90">
                现在就把喜欢的作品缓存到本地，收藏夹里装满你的心头好。
              </p>
              <a
                href="#contact"
                className="mt-4 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
              >
                立即开始
                <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}